'use client'

import Link from 'next/link'
import { useRouter, usePathname, useSearchParams } from 'next/navigation'

interface Props {
  categories: { name: string; slug: string }[]
  activeCategory: string | null
  activeSort: string
  totalCount: number
}

export function BrandFilters({ categories, activeCategory, activeSort, totalCount }: Props) {
  const router = useRouter()
  const pathname = usePathname()
  const sp = useSearchParams()

  function buildUrl(updates: Record<string, string | null>) {
    const params = new URLSearchParams(sp.toString())
    for (const [k, v] of Object.entries(updates)) {
      if (v === null) params.delete(k)
      else params.set(k, v)
    }
    const qs = params.toString()
    return qs ? `${pathname}?${qs}` : pathname
  }

  return (
    <div className="flex flex-wrap items-center gap-3 mb-6">
      <div className="flex flex-wrap gap-2 flex-1">
        <Link
          href={buildUrl({ kategoria: null })}
          className="px-3 py-1.5 rounded-full text-xs font-medium border transition-all"
          style={!activeCategory
            ? { backgroundColor: '#1FB8B0', color: '#03080F', borderColor: '#1FB8B0' }
            : { backgroundColor: 'transparent', color: 'rgba(255,255,255,0.75)', borderColor: 'rgba(255,255,255,0.15)' }}
        >
          Wszystkie ({totalCount})
        </Link>
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            href={buildUrl({ kategoria: cat.slug })}
            className="px-3 py-1.5 rounded-full text-xs font-medium border transition-all"
            style={activeCategory === cat.slug
              ? { backgroundColor: '#1FB8B0', color: '#03080F', borderColor: '#1FB8B0' }
              : { backgroundColor: 'transparent', color: 'rgba(255,255,255,0.75)', borderColor: 'rgba(255,255,255,0.15)' }}
          >
            {cat.name}
          </Link>
        ))}
      </div>
      <select
        value={activeSort}
        onChange={(e) =>
          router.push(buildUrl({ sortuj: e.target.value === 'nazwa' ? null : e.target.value }))
        }
        aria-label="Sortuj produkty"
        className="text-sm rounded-lg px-3 py-1.5"
        style={{ backgroundColor: '#0D1E30', color: 'rgba(255,255,255,0.7)', border: '1px solid rgba(255,255,255,0.12)' }}
      >
        <option value="nazwa">Sortuj: A–Z</option>
        <option value="cena-asc">Cena: rosnąco</option>
        <option value="cena-desc">Cena: malejąco</option>
        <option value="najnowsze">Najnowsze</option>
      </select>
    </div>
  )
}
